module.exports = __webpack_public_path__ + "account/assets/user-search-avatar.3d13d2ca.svg";